import React from 'react';
import Container from '@mui/material/Container';
import StepperForm from './StepperForm';

export default function FullVersionForm() {
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <StepperForm isFullVersion={true} />
    </Container>
  );
}
